import { UtilService } from '@app/utility/util.service';
var CreateQrcodeComponent = /** @class */ (function () {
    function CreateQrcodeComponent(util) {
        this.util = util;
    }
    CreateQrcodeComponent.prototype.ngOnInit = function () {
        CreateQRCode(this.util.GetUserID());
    };
    return CreateQrcodeComponent;
}());
export { CreateQrcodeComponent };



// WEBPACK FOOTER //
// ./src/app/member/create-qrcode/create-qrcode.component.ts.pre-build-optimizer.js